"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var use_context_selector_1 = require("use-context-selector");
var useBoolean_1 = tslib_1.__importDefault(require("@eduzz/houston-hooks/useBoolean"));
var ChevronDown_1 = tslib_1.__importDefault(require("@eduzz/houston-icons/ChevronDown"));
var DotsHorizontal_1 = tslib_1.__importDefault(require("@eduzz/houston-icons/DotsHorizontal"));
var houston_styles_1 = require("@eduzz/houston-styles");
var IconButton_1 = tslib_1.__importDefault(require("../../IconButton"));
var Spinner_1 = tslib_1.__importDefault(require("../../Loaders/Spinner"));
var Popover_1 = tslib_1.__importDefault(require("../../Popover"));
var usePopover_1 = tslib_1.__importDefault(require("../../Popover/usePopover"));
var context_1 = tslib_1.__importDefault(require("../context"));
var context_2 = tslib_1.__importDefault(require("./context"));
var actionIncremeter = 0;
var TableRow = function (_a) {
    var data = _a.data, index = _a.index, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["data", "index", "children", "className"]);
    var _b = (0, usePopover_1.default)(), openPopover = _b.openPopover, isPopoverOpened = _b.isPopoverOpened, popoverProps = _b.popoverProps, popoverTargetProps = _b.popoverTargetProps, closePopover = _b.closePopover;
    var _c = tslib_1.__read(React.useState(function () {
        var ref = ++actionIncremeter;
        return {
            actions: "hts-table-row-actions-".concat(ref),
            collapse: "hts-table-row-collapse-".concat(ref)
        };
    }), 1), portals = _c[0];
    var registerRow = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.registerRow; });
    var hasCollapseInRows = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.hasCollapseInRows; });
    var hasActionInRows = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.hasActionInRows; });
    var _d = tslib_1.__read((0, useBoolean_1.default)(false), 2), showCollapse = _d[0], toogleShowCollapse = _d[1];
    var _e = tslib_1.__read(React.useState(false), 2), actionLoading = _e[0], setActionLoading = _e[1];
    var _f = tslib_1.__read(React.useState(false), 2), hasCollapse = _f[0], setHasCollapse = _f[1];
    var _g = tslib_1.__read(React.useState(0), 2), actions = _g[0], setActions = _g[1];
    var hasActions = actions > 0;
    var registerCollapse = React.useCallback(function () {
        setHasCollapse(true);
        return function () { return setHasCollapse(false); };
    }, []);
    var registerAction = React.useCallback(function () {
        setActions(function (actions) { return ++actions; });
        return function () { return setActions(function (actions) { return --actions; }); };
    }, []);
    React.useEffect(function () {
        var unregister = registerRow({ hasActions: hasActions, hasCollapse: hasCollapse });
        return function () { return unregister(); };
    }, [hasActions, hasCollapse, registerRow]);
    var contextValue = React.useMemo(function () { return ({
        portals: portals,
        data: data,
        index: index,
        showCollapse: showCollapse,
        closeMenu: closePopover,
        registerAction: registerAction,
        setActionLoading: setActionLoading,
        registerCollapse: registerCollapse
    }); }, [closePopover, data, index, portals, registerAction, registerCollapse, showCollapse]);
    return ((0, jsx_runtime_1.jsxs)(context_2.default.Provider, tslib_1.__assign({ value: contextValue }, { children: [(0, jsx_runtime_1.jsxs)("tr", tslib_1.__assign({}, props, { className: className }, { children: [children, (0, jsx_runtime_1.jsxs)("td", tslib_1.__assign({ align: 'right', className: (0, houston_styles_1.cx)('hts-table-cell-action', !hasActionInRows && !hasCollapseInRows && 'hst-table-hidden') }, { children: [(0, jsx_runtime_1.jsx)(Popover_1.default, tslib_1.__assign({}, popoverProps, { placement: 'bottom-end', keepMounted: true }, { children: (0, jsx_runtime_1.jsx)("div", { id: portals.actions, className: 'hts-table-cell-action-menu' }) })), hasActions && ((0, jsx_runtime_1.jsx)(IconButton_1.default, tslib_1.__assign({ active: isPopoverOpened, disabled: actionLoading, onClick: openPopover }, popoverTargetProps, { children: actionLoading ? (0, jsx_runtime_1.jsx)(Spinner_1.default, { size: 18 }) : (0, jsx_runtime_1.jsx)(DotsHorizontal_1.default, {}) }))), hasCollapse && ((0, jsx_runtime_1.jsx)(IconButton_1.default, tslib_1.__assign({ onClick: toogleShowCollapse }, { children: (0, jsx_runtime_1.jsx)(ChevronDown_1.default, { className: (0, houston_styles_1.cx)('hts-table-cell-collapse-arrow', showCollapse && 'hts-table-cell-collapse-arrow-active') }) })))] }))] })), (0, jsx_runtime_1.jsx)("tr", { id: portals.collapse })] })));
};
/**
 * @deprecated Use Table from Antd
 * https://ant.design/components/table/
 */
exports.default = React.memo(TableRow);
